import {
  DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES,
  DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES,
  CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES,
  DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES,
  SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES,
  DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES,
  DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES,
  CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES
} from './constants';

export const deactivateProcessEnd = () => ({
  type: DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES
});

export const deactivateProcessStart = () => ({
  type: DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES
});

export const cancelDeactivateModal = () => ({
  type: CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES
});

export const displayDeactivateModal = ruleItem => ({
  type: DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES,
  payload: ruleItem
});

export const setBundlingRuleEventsInState = eventTypes => ({
  type: SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES,
  payload: eventTypes
});

export const displayActiveBundlingRules = activeRules => ({
  type: DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES,
  payload: activeRules
});

export const displayNewBundlingRule = () => ({
  type: DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES
});

export const cancelBundlingRuleItemForm = () => ({
  type: CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES
});



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/bundles/actionTypes.js